import { useEffect } from "react";

export const PreviewStrip = () => {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => {
      meta.remove();
    };
  }, []);

  return (
    <div className="label-mono fixed inset-x-0 top-0 z-[60] flex h-7 items-center justify-center gap-2 bg-leaf text-white" data-testid="preview-strip">
      <span className="h-1.5 w-1.5 animate-pulse bg-white" aria-hidden />
      Preview — not yet public
    </div>
  );
};
